export const siteInfo = {
  name: '动漫本子收藏指南',
  nameEn: 'Anime Doujinshi Collection Guide',
  tagline: '探索正版同人志的精彩世界',
  description: '探索动漫本子的世界，涵盖正版同人志、漫画手册、角色设定集等多种形式。本页为动漫爱好者提供动漫本子的选购攻略、收藏技巧与推荐资源，帮助你找到心仪的动漫本子，打造专属收藏体系。',
  keywords: '动漫本子,动漫同人志推荐,动漫本子收藏,同人手册购买,动漫设定集,漫画周边收藏,正版同人本',
  url: 'https://anime-doujinshi-guide.com',
  email: 'contact@anime-doujinshi-guide.com',
  phone: '+86 400-888-8888',
  address: '上海市静安区南京西路1788号动漫文化中心3F',
  foundingYear: '2018',
  socialLinks: {
    weibo: 'https://weibo.com/anime-doujinshi',
    bilibili: 'https://space.bilibili.com/anime-doujinshi',
    wechat: 'anime_doujinshi_guide',
    xiaohongshu: 'https://www.xiaohongshu.com/anime-doujinshi',
  },
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '分类浏览', href: '/category' },
  { label: '关于我们', href: '/about' },
];